package org.hs_soft.runmynesto.domain.config

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

enum class Theme(
    val hex: String,
    val rgb: CSSColorValue,
) {
    //Primary
    PrimaryMain(
        hex = "#2196F3",
        rgb =rgba(33, 150, 243, 1)
    ),

    PrimaryDark(
        hex = "#1E88E5",
        rgb = rgba(30, 136, 229, 1)
    ),
    PrimaryLight(
        hex = "#42A5F5",
        rgb = rgb(66, 165, 245)
    ),
    PrimaryStatesHover(
        hex = "#0288D10A",
        rgb =rgba(2, 136, 209, 0.04)
    ),

    PrimaryStatesSelected(
        hex = "#2196F314",
        rgb =rgba(33, 150, 243, 0.08)
    ),

    PrimaryStatesFocus(
        hex = "#2196F31F",
        rgb =rgba(33, 150, 243, 0.12)
    ),

    PrimaryStatesFocusVisible(
        hex = "#2196F34D",
        rgb = rgba(33, 150, 243, 0.3)
    ),

    PrimaryStatesOutlinedBorder(
        hex = "#2196F380",
        rgb =rgba(33, 150, 243, 0.5)
    ),
    PrimaryInfoLight(
        hex ="#03A9F4" ,
        rgb = rgba(3, 169, 244, 1)
    ),
    Blue50(
        hex = "#E3F2FD",
        rgb=rgba(227, 242, 253, 1),
    ),
    //Text Color------------------------------------------------------

    TextPrimary(
        hex = "#000000DD",
        rgb = rgba(r = 0, g = 0, b = 0, a = 0.87),
    ),
    TextSecondary(
        hex ="#0000008F" ,
        rgb=rgba(0, 0, 0, 0.60)
    ),
    TextDisabled(
        hex = "#00000061",
        rgb= rgba(0, 0, 0, 0.38)
    ),
    //Secondary --------------------------------------------------------
    SecondaryLight(
        hex ="#BA68C8" ,
        rgb =rgb (186, 104, 200,),
    ),

    //Action Colors---------------------------------------
    ActionActive(
        hex = "#0000008F",
        rgb = rgba(0, 0, 0, 0.56)
    ),
    ActionHover(
        hex = "#0000000A",
        rgb= rgba(0,0,0,0.04),
    ),
    SolidActionHover(
        hex = "#F6F6F6",
        rgb = rgb(246, 246, 246)
    ),
    ActionSelected(
        hex = "#00000014",
        rgb= rgba(0,0,0,0.08),
    ),
    ActionDisabledBackground(
        hex = "#0000001F",
        rgb= rgba(0,0,0,0.12),
    ),
    ActionFocused(
        hex = "#0000001F",
        rgb= rgba(0,0,0,0.12),
    ),
    ActionDisabled(
        hex = "#00000061",
        rgb= rgba(0, 0, 0, 0.38)
    ),
    InputEnabledBorder(
        hex = "#0000003B",
        rgb=rgba(0, 0, 0, 0.23),
    ),

    Gray3E(
        hex = "#3E3E3E",
        rgb= rgb(62,62,62)
    ),
    GrayAlpha02(
        hex = "00000005",
        rgb= rgba(0,0,0,0.02)
    ),
    WhiteFA(
        hex = "#FAFAFA",
        rgb=rgba(250, 250, 250, 1),
    ),

    Gray9E(
        hex = "#9E9E9E",
        rgb= rgba(158, 158, 158, 1)
    ),
    Gray55(
        hex = "#F5F5F5",
        rgb = rgb(245, 245, 245)
    ),
    Gray10(
        hex = "#0000001A",
        rgb =rgba(0, 0, 0, 0.1)
    ),
    Gray400(
        hex = "#BDBDBD",
        rgb=rgb(189, 189, 189)
    ),

    //Error Colors-----------------------------------------------
    ErrorMain(
        hex = "#D32F2F",
        rgb = rgb(211, 47, 47)
    ),
    ErrorDark(
        hex = "#C62828",
        rgb = rgb(198, 40, 40)
    ),
    ErrorLight(
        hex = "#EF5350",
        rgb = rgb(239, 83, 80)
    ),
    ErrorStatesHover(
        hex = "#D32F2F0A",
        rgb = rgba(211, 47, 47, 0.04)
    ),
    ErrorStatesSelected(
        hex = "#D32F2F14",
        rgb = rgba(211, 47, 47, 0.08)
    ),
    ErrorStatesFocus(
        hex = "#D32F2F1F",
        rgb = rgba(211, 47, 47, 0.12)
    ),
    ErrorStateFocusVisible(
        hex = "#D32F2F4D",
        rgb = rgba(211, 47, 47, 0.3)
    ),
    ErrorStatesOutlinedBorder(
        hex = "#D32F2F80",
        rgb = rgba(211, 47, 47, 0.5)
    ),
    ErrorDialogColor(
        rgb=rgb(253, 237, 237),
        hex="#FDEDED"
    ),
    ErrorText(
        rgb = rgb(95, 33, 32),
        hex ="#5F2120"
    ),
    //Warning colors---------------------------------

    WarningMain(
        hex = "#ED6C02",
        rgb = rgb(237, 108, 2)
    ),
    WarningDark(
        hex = "#E65100",
        rgb = rgb(230, 81, 0)
    ),
    WarningLight(
        hex = "#FF9800",
        rgb = rgb(255, 152, 0)
    ),
    WarningStatesHover(
        hex = "#ED6C020A",
        rgb = rgba(237, 108, 2, 0.04)
    ),
    WarningStatesSelected(
        hex = "#ED6C0214",
        rgb = rgba(237, 108, 2, 0.08)
    ),
    WarningStatesFocus(
        hex = "#ED6C021F",
        rgb = rgba(237, 108, 2, 0.12)
    ),
    WarningStateFocusVisible(
        hex = "#ED6C024D",
        rgb = rgba(237, 108, 2, 0.3)
    ),
    WarningStatesOutlinedBorder(
        hex = "#ED6C0280",
        rgb = rgba(237, 108, 2, 0.5)
    ),
    //-------------------------------------------------
    Emerald(
        hex = "#26C6DA",
        rgb=rgb(38, 198, 218),
    ),

    Transparent(
        hex = "#00000000",
        rgb = rgba(r = 0, g = 0, b = 0, a = 0.0),
    ),
    YellowAlpha20(
        hex = "#4AFFFF00",
        rgb = rgba(255, 255, 0, 0.4)
    ),
    Yellow700(
        hex = "#FBC02D",
        rgb= rgb(251, 192, 45)
    ),

    //Success Colors----------------------------------------------------------

    SuccessDark(
        hex = "#1B5E20",
        rgb = rgb(27, 94, 32)
    ),
    SuccessMain(
        hex = "#2E7D32",
        rgb = rgb(46, 125, 50)
    ),
    SuccessLight(
        hex = "#4CAF50",
        rgb = rgb(76, 175, 80)
    ),
    SuccessHover(
        hex = "#2E7D320A",
        rgb = rgba(46, 125, 50, 0.04)
    ),
    SuccessSelected(
        hex = "#2E7D3214",
        rgb = rgba(46, 125, 50, 0.08)
    ),
    SuccessFocusVisible(
        hex = "#2E7D324D",
        rgb = rgba(46, 125, 50, 0.30)
    ),
    SuccessOutlinedBorder(
        hex = "#2E7D3280",
        rgb = rgba(46, 125, 50, 0.50)
    ),
    Green50(
        hex ="#E8F5E9" ,
        rgb= rgba(232, 245, 233, 1)
    ),
    SuccessAlertFill(
        hex ="#EDF7ED",
        rgb= rgb(237, 247, 237)
    ),
    Green100(
        hex ="#EDF7ED",
        rgb= rgb(237, 247, 237)
    ),

    //White Colors-----------------------------------------------

    WhiteMain(
        hex = "#FFFFFF",
        rgb = rgb(255, 255, 255)
    ),
    WhiteStatesHover(
        hex = "#FFFFFF0A",
        rgb = rgba(255, 255, 255, 0.04)
    ),
    WhiteStatesSelected(
        hex = "#FFFFFF14",
        rgb = rgba(255, 255, 255, 0.08)
    ),
    WhiteStatesFocus(
        hex = "#FFFFFF1F",
        rgb = rgba(255, 255, 255, 0.12)
    ),
    WhiteStateFocusVisible(
        hex = "#FFFFFF4D",
        rgb = rgba(255, 255, 255, 0.3)
    ),
    WhiteStatesOutlinedBorder(
        hex = "#FFFFFF80",
        rgb = rgba(255, 255, 255, 0.5)
    ),
    //-------------------------------------------------------

    White(
        hex = "#FFFFFF",
        rgb = rgb(r = 255, g = 255, b = 255),
    ),
    Divider(
        hex = "#0000001F",
        rgb= rgba(0,0,0,0.12),
    ),

    Tooltip(
        hex ="#616161E5",
        rgb= rgba(97,97,97,a=0.9f)
    ),

    DarkGrey(
        hex ="#B0B0B0" ,
        rgb=rgba(176, 176, 176, 1),
    ),

    //Data Assistants Colors-----------------------------------------------
    LightOrange(
        hex ="#F48C07" ,
        rgb=rgba(244, 140, 7, 1),
    ),

    LightOrangeFocus(
        hex ="#F48C07" ,
        rgb=rgba(244, 140, 7, 0.12),
    )


}